<h3 mat-dialog-title class="action-dialog-title">Take Action</h3>

<mat-dialog-content class="action-dialog-content">
    <!-- Step Indicator -->
    <div class="step-indicator">
        <div class="step-item" [class.step-active]="step === 1" [class.step-completed]="isStepCompleted(1)">
            <div class="step-circle">
                @if (isStepCompleted(1)) {
                <mat-icon class="step-check-icon">edit</mat-icon>
                } @else {
                <span>1</span>
                }
            </div>
            <span class="step-label">Choose Action</span>
        </div>

        <div class="step-connector" [class.completed]="isStepCompleted(1)"></div>

        <div class="step-item" [class.step-active]="step === 2" [class.step-completed]="isStepCompleted(2)">
            <div class="step-circle">
                @if (isStepCompleted(2)) {
                <mat-icon class="step-check-icon">edit</mat-icon>
                } @else {
                <span>2</span>
                }
            </div>
            <span class="step-label">Details</span>
        </div>

        <div class="step-connector" [class.completed]="isStepCompleted(2)"></div>

        <div class="step-item" [class.step-active]="step === 3">
            <div class="step-circle"><span>3</span></div>
            <span class="step-label">Confirm</span>
        </div>
    </div>

    <!-- Validation Errors -->
    @if (validationErrors.length > 0) {
    <div class="alert alert-danger" role="alert">
        <ul class="mb-0">
            @for (err of validationErrors; track err) {
            <li>{{ err }}</li>
            }
        </ul>
    </div>
    }

    <!-- Step 1: Choose Action -->
    @if (step === 1) {
    <p class="step-description">Select an action for this application:</p>
    <div class="action-options">
        @for (option of actionOptions; track option.id) {
        <div class="action-option" [class.selected]="selectedAction === option.id" (click)="selectAction(option.id)">
            <div class="action-option-check">
                @if (selectedAction === option.id) {
                <mat-icon class="option-check-icon">check_circle</mat-icon>
                } @else {
                <mat-icon class="option-icon">{{ option.icon }}</mat-icon>
                }
            </div>
            <div class="action-option-text">
                <div class="action-option-title">{{ option.title }}</div>
                <div class="action-option-desc">{{ option.description }}</div>
            </div>
        </div>
        }
    </div>
    }


    <!-- Step 2: Details -->
    @if (step === 2) {
    @if (data.isAMORETeam && selectedAction === 'assign-amore') {
    <p class="step-description">Choose assignment type:</p>
    <div class="form-group amore-assign-radio-group">
        <input type="radio" id="amore-assign-myself" name="amoreAssignType" value="myself"
            [(ngModel)]="amoreAssignType">
        <label for="amore-assign-myself">Assign to Myself</label>
        <input type="radio" id="amore-assign-architect" name="amoreAssignType" value="architect"
            [(ngModel)]="amoreAssignType">
        <label for="amore-assign-architect">Assign to Architect</label>
        <input type="radio" id="amore-assign-pod" name="amoreAssignType" value="pod" [(ngModel)]="amoreAssignType">
        <label for="amore-assign-pod">Assign to POD</label>
    </div>

    <!-- Assign to Myself -->
    @if (amoreAssignType === 'myself') {
    <div class="form-group">
        <label>Email</label>
        <input type="text" class="form-control" [value]="currentUserEmail" readonly>
    </div>
    <div class="form-group">
        <label for="assign-notes">Notes</label>
        <textarea id="assign-notes" class="form-control" rows="3" [(ngModel)]="assignNotes"
            placeholder="Enter additional notes (optional)"></textarea>
    </div>
    <div class="form-group">
        <div class="consent-wrapper">
            <input type="checkbox" [(ngModel)]="consentProvided">
            <label class="mt-2">I provide my consent to assign this application to myself.</label>
        </div>
    </div>
    }

    <!-- Assign to Architect -->
    @if (amoreAssignType === 'architect') {
    <div class="form-group">
        <label for="assign-to-input">Assign to: <span class="text-danger">*</span></label>
        <div class="autocomplete-wrapper">
            <input type="text" id="assign-to-input" class="form-control" placeholder="Search user (min 3 characters)"
                [formControl]="emailControl" (focus)="showSuggestions = true" (blur)="onEmailBlur()" autocomplete="off">
            @if (showSuggestions && (filteredUsers$ | async); as users) {
            <ul class="autocomplete-dropdown">
                @if (users.length === 0) {
                <li class="autocomplete-empty">No users found</li>
                }
                @for (user of users; track user) {
                <li class="autocomplete-option" (mousedown)="onUserSelected(user)">
                    <span class="fw-semibold">{{ user.displayName }}</span>
                    <small class="text-muted d-block">{{ user.mail }}</small>
                </li>
                }
            </ul>
            }
        </div>
    </div>
    <div class="form-group">
        <label for="assign-notes">Notes</label>
        <textarea id="assign-notes" class="form-control" rows="3" [(ngModel)]="assignNotes"
            placeholder="Enter additional notes (optional)"></textarea>
    </div>
    <div class="form-group">
        <div class="consent-wrapper">
            <input type="checkbox" [(ngModel)]="consentProvided">
            <label class="mt-2">I provide my consent to assign this application to Architect.</label>
        </div>
    </div>
    }

    <!-- Assign to POD -->
    @if (amoreAssignType === 'pod') {
    <div class="form-group">
        <label for="pod-select">POD <span class="text-danger">*</span></label>
        <select id="pod-select" class="form-control" [(ngModel)]="selectedPodId">
            <option [ngValue]="null" disabled selected>Select a POD...</option>
            @for (pod of pods; track pod.podId) {
            <option [ngValue]="pod.podId">{{ pod.name }}</option>
            }
        </select>
    </div>
    <div class="form-group">
        <label for="assign-notes">Notes</label>
        <textarea id="assign-notes" class="form-control" rows="3" [(ngModel)]="assignNotes"
            placeholder="Enter additional notes (optional)"></textarea>
    </div>
    <div class="form-group">
        <div class="consent-wrapper">
            <input type="checkbox" [(ngModel)]="consentProvided">
            <label class="mt-2">I provide my consent to assign this application to the selected POD.</label>
        </div>
    </div>
    }
    } @else {
    <!-- Original non-AMORE step 2 content -->
    <!-- Override Assessment -->
    @if (selectedAction === 'override') {
    <p class="step-description">Provide a final decision and override reason.</p>
    <div class="form-group">
        <label for="final-decision">Final Decision <span class="text-danger">*</span></label>
        <select id="final-decision" class="form-control" [(ngModel)]="overrideAction">
            <option value="" disabled selected>Select a decision...</option>
            @for (option of modernizationOptions; track option.value) {
            <option [value]="option.value">{{ option.label }}</option>
            }
        </select>
    </div>
    <div class="form-group">
        <label for="override-reason">Override Reason <span class="text-danger">*</span></label>
        <textarea id="override-reason" class="form-control" rows="4" [(ngModel)]="overrideReason"
            placeholder="Explain why you are overriding the AI recommendation..."></textarea>
    </div>
    }
    <!-- Assign to Technical Team / AMORE Team -->
    @if (selectedAction === 'assign-technical' || selectedAction === 'assign-amore') {
    @if (selectedAction === 'assign-technical') {
    <p class="step-description">Assign this application to a team member for review.</p>
    } @else {
    <p class="step-description">Assign this application to the AMORE team for implementation.</p>
    }
    @if (selectedAction === 'assign-technical') {
    <div class="form-group">
        <label for="assign-to-input">Assign to: <span class="text-danger">*</span></label>
        <div class="autocomplete-wrapper">
            <input type="text" id="assign-to-input" class="form-control" placeholder="Search user (min 3 characters)"
                [formControl]="emailControl" (focus)="showSuggestions = true" (blur)="onEmailBlur()" autocomplete="off">
            @if (showSuggestions && (filteredUsers$ | async); as users) {
            <ul class="autocomplete-dropdown">
                @if (users.length === 0) {
                <li class="autocomplete-empty">No users found</li>
                }
                @for (user of users; track user) {
                <li class="autocomplete-option" (mousedown)="onUserSelected(user)">
                    <span class="fw-semibold">{{ user.displayName }}</span>
                    <small class="text-muted d-block">{{ user.mail }}</small>
                </li>
                }
            </ul>
            }
        </div>
    </div>
    }
    <div class="form-group">
        <label for="assign-notes">Notes</label>
        <textarea id="assign-notes" class="form-control" rows="3" [(ngModel)]="assignNotes"
            placeholder="Enter additional notes (optional)"></textarea>
    </div>
    <div class="form-group">
        <div class="consent-wrapper">
            <input type="checkbox" [(ngModel)]="consentProvided">
            <label for="assign-consent" class="mt-2">I provide my consent to assign this application to {{
                selectedAction === 'assign-technical' ? 'Technical Owner' : 'AMORE Team' }}.</label>
        </div>
    </div>
    }
    <!-- Reject Assessment -->
    @if (selectedAction === 'reject') {
    <p class="step-description">Provide a reason for rejecting this assessment.</p>
    <div class="form-group">
        <label for="rejection-reason">Rejection Reason <span class="text-danger">*</span></label>
        <select id="rejection-reason" class="form-control" [(ngModel)]="rejectionReasonId"
            (ngModelChange)="onReasonChange($event)">
            <option [ngValue]="null" disabled selected>Select a reason...</option>
            @for (reason of getFilteredReasons(); track reason) {
            <option [ngValue]="reason.rejectionReasonId">{{ reason.rejectionReason }}</option>
            }
        </select>
    </div>
    @if (isOtherReason()) {
    <div class="form-group">
        <label for="other-reason-text">Detailed Reason <span class="text-danger">*</span></label>
        <textarea id="other-reason-text" class="form-control" rows="4" [(ngModel)]="otherReasonText"
            placeholder="Please provide a detailed reason for rejection..."></textarea>
    </div>
    }
    }
    }
    }

    <!-- Step 3: Confirm -->
    @if (step === 3) {
    <div class="confirm-summary">
        <div class="confirm-title">{{ confirmSummaryTitle }}</div>
        <!-- Show AI recommendation if action is Override -->
        @if (selectedAction === 'override') {
        <div class="ai-recommendation">AI Recommendation: {{ data.currentRecommendation }}</div>
        }
        <div class="confirm-detail">{{ confirmSummaryDetail }}</div>
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions class="action-dialog-footer">
    @if (step > 1) {
    <button class="button small btn-back-action" (click)="onBack()">‹ Back</button>
    }
    <button class="button small btn-cancel-action" (click)="onCancel()">Cancel</button>
    <span class="footer-spacer"></span>
    @if (step === 3 && selectedAction === 'approve') {
        <button class="button small btn-secondary mr-2" (click)="openPatUpdateDialog()">Update PAT</button>
    }
    @if (step < 3) { <button class="button small" (click)="onNext()">Next</button>
        } @else {
        <button class="button small" (click)="onSubmit()">Submit</button>
        }
</mat-dialog-actions>